export const dateDifInHours = (startDate, endDate) => {
  let timeDiff = endDate.getTime() - startDate.getTime()
  return Math.ceil(timeDiff / (1000 * 3600))
}

export const formatDate = (inputString) => {
  let dateObj = new Date(inputString)
  let year = dateObj.getFullYear();

  let month = (1 + dateObj.getMonth()).toString();
  month = month.length > 1 ? month : '0' + month;

  let day = dateObj.getDate().toString();
  day = day.length > 1 ? day : '0' + day;

  return month + '-' + day + '-' + year;
}



// WEBPACK FOOTER //
// ./src/routes/LocalDeals/helpers/dateTimeHelper.js